const rates = {
  promotional: {
    years: 10,
    capital: 35,
    nominalInterest: 0.99,
    monthlyCost: 85,
    registrationCost: 1516,
    preparationFee: 2990,
    branch: 921,
  },
  standard: {
    years: 10,
    capital: 35,
    nominalInterest: 1.99,
    monthlyCost: 85,
    registrationCost: 1516,
    preparationFee: 2990,
    branch: 821,
  },
};

export default rates;
